import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Spin } from 'antd'

import AuthActions from '../Redux/AuthRedux'

function SignUpCheckPage (props) {
  const { match } = props;
  const { hash, role } = match.params;

  useEffect(()=>{
    props.checkInviteHash(hash, role);
  }, [0]);

  return (
    <Spin spinning={true} size="large">
      <div className="page-full-wrapper"/>
    </Spin>
  )
}

const mapDispatchToProps = (dispatch) => ({
  checkInviteHash: (hash, role) => dispatch(AuthActions.inviteHashRequest(hash, role)),
})

export default connect(null, mapDispatchToProps)(SignUpCheckPage)
